import React from 'react'
import SecondHeader from '../../components/SecondHeader/SecondHeader'
import Footer from '../../components/Footer/Footer'
import ShareYourExperienceBox from '../../components/sampleComponents/shareYourExperienceBox/ShareYourExperienceBox'

const ShareYourExperience = () => {
    return (
        <>
            <SecondHeader />
            <ShareYourExperienceBox/>
            <Footer/>
        </>
    )
}

export default ShareYourExperience